export default __webpack_public_path__ + "static/media/UnVerified.f321c756.svg";